// extracted by mini-css-extract-plugin
export default {"tabsContainer":"TabsField_tabsContainer__PzwGC","tabPanel":"TabsField_tabPanel__UKM-d","tabContent":"TabsField_tabContent__AMNK8"};